module.exports = __webpack_public_path__ + "static/media/cocktail.201ca006.jpg";